import { useAppSelector } from 'app/hooks';
import { MemoizedIconSkeleton } from 'components/LazySvg';
import Img from 'components/Img';
import {
  selectBrandLogoUrl,
  selectBrandName,
} from 'services/brand/brandSelectors';
import { QaHeader } from 'testdata/constants';
import styles from './index.module.scss';

function BrandLogo() {
  const logoUrl = useAppSelector(selectBrandLogoUrl);
  const brandName = useAppSelector(selectBrandName);

  if (!logoUrl) {
    return <MemoizedIconSkeleton />;
  }

  return (
    <div className={styles.logoWrapper}>
      <Img
        src={logoUrl}
        alt={brandName}
        width='auto'
        data-qa-selector={QaHeader.imageLogo}
      />
    </div>
  );
}

export default BrandLogo;
